<template>
  <div id="wiatting-for-choose-interview-time" class="container-sm">
    <ordering-bread :order-status="dataModel.order_status"></ordering-bread>

    <div class="page-content">
      <ordering-step :order="dataModel" :current-page-order-status="10" :disabled="isUpdatedIntervieData"></ordering-step>

      <ordering-order-basic-info v-if="dataModel.user_order_id" :order="dataModel" @changeDepartDate="changeDepartDate" from="order_interview"></ordering-order-basic-info>

      <div class="cue-container">
        <div class="cue-container-label">
          <img class="icon" src="https://o.666visa.cn/static/ssqpeer/common/icon_embassy.png" alt="">
          <div class="text">赴馆信息</div>
        </div>
        <div class="cue">
          <div class="cue-item">请选择3个方便前往使馆的时间；<span class="mark">注意：所选时间为优先预约时间</span>，若无法预约，签证专家将联系您重新确认。</div>
          <div class="cue-item">预约成功后，如需修改赴馆时间，需补缴 <span class="mark">{{getUpdateDatePrice/100}}元/人/次</span> 重新预约。</div>
          <div v-if="earlistDateData && earlistDateData.interview_notice" class="cue-item">{{earlistDateData.interview_notice}}</div>
        </div>
      </div>

      <div class="center-content">
        <interview-date-select-form
          v-if="earlistDateData && interviewformData"
          :order="dataModel"
          v-model="interviewformData"
          :holiday="fullHoliday"
          :error="interviewFormDataErrorMap"
          :earlist-date="earlistDateData"
          :cityDateEmpty="cityDateEmpty"
          @switchInterviewTogether="switchInterviewTogether">
        </interview-date-select-form>
        <div class="button-area">
          <!-- 线上订单，并且没有更新过数据，则才可以点击上一步 -->
          <div v-if="dataModel.offline === 0 && !isUpdatedIntervieData" class="step-button" @click="goBack">
            <img src="../../assets/imgs/application/previous-step.png">
            <span>上一步</span>
          </div>
          <div class="step-button" @click="goNext">
            <img src="../../assets/imgs/application/next-step.png">
            <span>下一步</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../libs/utils';
import Http from '../../libs/http';
import interviewMixin from '../../mixins/interview';
import orderingService from '../../services/ordering-service';
import orderingBread from './components/ordering-bread';
import orderingStep from './components/ordering-step';
import orderingOrderBasicInfo from './components/ordering-order-basic-info';
import interviewDateSelectForm from '../../components/interview-date-select-form';
// import insurancePopup from '../businessInsurance/popupBox/index';

export default {
  name: 'wiatting-for-choose-interview-time',
  mixins: [interviewMixin], // 注意此处的mixin
  components: {
    interviewDateSelectForm,
    orderingBread,
    orderingStep,
    orderingOrderBasicInfo,
  },
  data() {
    return {
      orderId: +this.$route.params.oid,
      dataModel: {},
      interviewformData: null,
      firstInterviewformData: null, // 第一次的赴馆信息，这个数据用于判定是否更改过赴馆信息
      interviewFormDataErrorMap: null,
      interviewSubmitted: false,
      holidays: [],
      fullHoliday: [],
      earlistDateData: null,
    };
  },
  computed: {
    orderStatus() {
      // 1:待上传资料;  2:待填写申请表;  2.5:待确认;  3:待支付
      return this.dataModel.order_status;
    },
    // 获取每次修改赴馆时间价格
    getUpdateDatePrice() {
      return this.earlistDateData
        ? this.earlistDateData.interview_change_fee
        : '';
    },
    // 是否更新过赴馆信息，更新过需要禁用上方跳转和上一步按钮，要不然会没保存,
    isUpdatedIntervieData() {
      // 如果都没有数据，则没有更新
      if (!this.firstInterviewformData || !this.interviewformData) {
        return false;
      }

      // 是否一起赴馆，不相等则说明更新了
      if (this.firstInterviewformData.interview_together !== this.interviewformData.interview_together) {
        return true;
      }

      const first = this.firstInterviewformData.data.map(item => ({
        date_choice: item.date_choice,
        order_applicant_id: item.order_applicant_id,
        other_date: item.date_choice === 2 ? item.other_date : '',
        preferred_date: item.date_choice === 0 ? item.preferred_date : [],
        embassy_district_id: item.embassy_district_id,
      }));
      const now = this.interviewformData.data.map(item => ({
        date_choice: item.date_choice,
        order_applicant_id: item.order_applicant_id,
        other_date: item.date_choice === 2 ? item.other_date : '',
        preferred_date: item.date_choice === 0 ? item.preferred_date : [],
        embassy_district_id: item.embassy_district_id,
      }));
      if (this.firstInterviewformData.interview_together === 0) {
        // 分开赴馆
        // 直接通过字符串进行判定是否完全一致，相等说明数据没有更新
        if (JSON.stringify(first) === JSON.stringify(now)) {
          return false;
        }
      } else {
        // 一起赴馆
        // 直接通过字符串进行判定是否完全一致，相等说明数据没有更新
        if (JSON.stringify(first[0]) === JSON.stringify(now[0])) {
          return false;
        }
      }

      // 数据不等，说明数据更新了
      return true;
    },
  },
  methods: {
    // 返回
    goBack() {
      const allSteps = orderingService.getOrderSteps(this.dataModel);
      let idx = null;
      allSteps.forEach((tab, index) => {
        if (tab.className === 'interview') {
          idx = index - 1;
        }
      });
      this.$router.push(allSteps[idx].routeConfig);
    },

    // 选择赴馆日期下一步
    async goNext() {
      this.interviewSubmitted = true;
      const valid = this.validateInterviewDate();
      if (valid) {
        const interviewDateIsOutdated = this._checkInterviewDateIsOutDated();
        if (!interviewDateIsOutdated) {
          await this.checkInterviewDate();
          
          utils.msgbox
            .confirm(
              '使馆预约操作复杂，若预约成功后需要修改，可能耽误您的办理进度。确定所选日期范围内能够准时前往使馆？',
              '温馨提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '再想想',
                type: 'warning',
              },
            )
            .then(() => {
              this.trimFormData();
              return Http.post(
                '/order_interview_time_submit',
                this.interviewformData,
              );
            })
            .then(() => {
              const allSteps = orderingService.getOrderSteps(this.dataModel);


              // 对于资料上传页面来说, 一定有下一步
              const nextRouter = allSteps[allSteps.length - 1].routeConfig;

              // if (this.dataModel.product_insurance && this.dataModel.product_insurance.insurance_type === 2 && this.dataModel.order_insurance === undefined && nextRouter.name === 'orderComfirm') {
              //   .show(this.dataModel, this).then((e) => {
              //     if (e) {
              //       this.$router.push(nextRouter);

              //       // 滚到顶部
              //       utils.scrollTop();
              //     }
              //   });
              // } else {
              //   this.$router.push(nextRouter);
              // }
              this.$router.push(nextRouter);

            }).catch((e) => {
              if (e) console.log(e);
            });
        }
      } else {
        return utils.msg.warning('请完善赴馆日期信息');
      }
    },
    // 更改选择时间回调
    changeDepartDate(date) {
      this.dataModel.depart_date = date;
    },

    // 获取订单信息
    getOrder() {
      orderingService.getOrderData(this.orderId).then((data) => {
        document.title = `${data.country}国家签证办理-上上签同业签证平台，旅游同业签证办理的智能平台`;
        // 判断是否已支付过
        if (data.pay_info && data.pay_info.pay_status > 0) {
          utils.msg.warning('订单已支付');
          return this.$router.replace({
            name: 'orderDetail',
            params: { oid: this.orderId },
          });
        }

        // 拿到数据
        this.dataModel = data;
        this.getEarlistDateData().then(() => {
          this.getCountryHoliday();
        }).catch((e) => {
          if (e) console.log(e);
        });
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取最早赴馆日期信息
    getEarlistDateData() {
      return orderingService.getEarlistDateData(this.orderId).then((data) => {
        this.earlistDateData = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 满足条件才会检查赴馆日期是否有过期(已确认)
    checkInterviewDateIsOutDatedIfNeeded() {
      if (
        this.orderStatus === 10 ||
        this.orderStatus === 2 ||
        (this.orderStatus === 3 &&
          (this.dataModel.need_delivery > 0 ||
            this.dataModel.need_interview > 0))
      ) {
        if (this.validateInterviewDate()) {
          // 通过校验才检查是否有日期过期
          return this._checkInterviewDateIsOutDated();
        }
      }
    },

    // 获取国家假期
    getCountryHoliday() {
      orderingService
        .countryHolidayQuery(this.dataModel.visa_country_id)
        .then((data) => {
          if (!Object.keys(data).length) return;

          this.interviewformData = orderingService.extractInterviewInfo(
            this.dataModel,
          );
          // 第一次的赴馆信息，这个数据用于判定是否更改过赴馆信息
          this.firstInterviewformData = JSON.parse(JSON.stringify(this.interviewformData));
          this.holidays = data[Object.keys(data)[0]];
          this.handleHolidayArr();

          // 检查是否有赴馆日期过期
          this.checkInterviewDateIsOutDatedIfNeeded();
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
    // 校验赴馆日期是否晚于出行日期
    async checkInterviewDate() {
      let error = false;
      this.interviewformData.data.forEach((interviewItem) => {
        if (interviewItem.date_choice !== 0) return;

        if (interviewItem.preferred_date.some(item => item.date > this.dataModel.depart_date)) {
          error = true;
        }
      });
      if (error) {
        await utils.msgbox
          .confirm(
            '当前指定赴馆日期存在晚于期望出行日期，确定进行提交吗？',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '再想想',
              type: 'warning',
            },
          );

      }
    },
  },
  created() {
    this.getOrder();
  },
  // destroyed() {
  //   insurancePopup.hide();
  // },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';

#wiatting-for-choose-interview-time {
  margin-bottom: 100px;
  .page-content {
    box-shadow: 0 1px 7px -3px #555;
    .cue-container {
      padding: 0 30px 16px;
      background: #ffffff;
      .cue-container-label{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 8px;
        height: 20px;
        .icon{
          display: block;
          width: 16px;
          height: 16px;
        }
        .text{
          font-weight: 400;
          font-size: 16px;
          color: #2F333D;
        }
      }
      .cue {
          color: #8F99A0;
          font-size: 12px;
          padding-left: 26px;
          margin-top: 16px;
          
          .mark {
            color: #ff5a60;
          }
          .cue-item {
            position: relative;
            padding-left: 12px;
            
            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 4px;
              height: 4px;
              background-color: #8F99A0;
              border-radius: 50%;
            }
            
            & + .cue-item {
              margin-top: 8px;
            }
          }
        }

    }
    .center-content {
      padding: 1px 40px 40px 52px;
      background-color: white;
      .button-area {
        padding-top: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        .step-button {
          cursor: pointer;
          display: flex;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
          }
          span {
            font-size: 14px;
            color: @main;
            margin-left: 10px;
          }
        }

        .step-button + .step-button {
          margin-left: 70px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/WaittingForChooseInterviewTime.vue